/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { useForm } from "react-hook-form";
import { REGEX_TAXID, REGEX_PHONE, REGEX_BIN, REGEX_EMAIL, REGEX_NUMBER } from "../../util/RegEx";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Box, Tabs, Tab } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AfbCustomer = (props) => {
	const [zPos, setZPos] = useState(45)
  const { handleSubmit, register, errors } = useForm();
  const [disabledButton, setDisabledButton] = useState(true);
  const [disabledCP, setDisabledCP] = useState(true);
  const history = useHistory();
  const [cols, setCols] = useState([]);
  const [codeRep, setCodeRep] = useState("52");
  const [codeCom, setCodeCom] = useState("52");
  const [stateDisabled, setStateDisabled] = useState(true);
  const [errCodeRep, setErrCodeRep] = useState(false);
  const [errCodeCom, setErrCodeCom] = useState(false);
  const [content, setContent] = useState({
    general: { bdate: new Date(), bstate: "", bcountry: "", code: "" },
    address: { zip: "", town: "", state: "", country: "", locality: "" },
    lead: { code: "" },
  });
  const [form, setForm] = useState({
    general: { email: "", bcountry: "", bdate: new Date(), bstate: "", gname: "", lname: "", occupation: "", phone: "", taxid: "", populationid: "" },
    address: { country: "", extnum: "", intnum: "", locality: "", state: "", street: "", town: "", zip: "" },
    space: { name: "", description: "", cc: 'INTELIGENCIA_FI', account_number: "" },
    identity: { validation_result: {risk_level: {score: 0, warning_results: false, score_level: ""}}},
  });
  const [errs, setErrs] = useState({
    general: { email: false, bcountry: false, bdate: false, bstate: false, gname: false, lname: false, occupation: false, phone: false, taxid: false, populationid: false },
    address: { country: false, extnum: false, intnum: false, locality: false, state: false, street: false, town: false, zip: false },
    space: { name: false, description: false, cc: false, account_number: false },
  });
  const [tabActive, setTabActive] = useState("manual");
  const [defaultCountry, setDefaultCountry] = React.useState("");

  useEffect(() => {
    for (let c in props.catalogs.country) {
      if ( props.catalogs.country[c].v === "Mexico" || props.catalogs.country[c].v === "México") {
        setDefaultCountry(props.catalogs.country[c].k);
        content.general.code = props.catalogs.country[c].m[0].dial;
        content.lead.code = props.catalogs.country[c].m[0].dial;
        break;
      }
    }
  }, []);

  const changeTab = (index) => {
    setTabActive(index);
  };

  const verifyForm = (data, e) => {
    let cont = 1;
    let verify = 1;

    let keysFormGeneral = Object.keys(data.general);
    let keysFormAddress = Object.keys(data.address);
    let keysFormSpace = Object.keys(data.space);

    for (let i = 0; i < keysFormGeneral.length; i++) {
      if (keysFormGeneral[i] == "bstate") {
        let value = data.general["bcountry"];
        for (let j = 0; j < props.catalogs.country.length; j++) {
          let elem = props.catalogs.country[j];
          if (elem.k == value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              cont = cont * (data.general["bstate"] ? 1 : 0);
              verify = verify * (e.general["bstate"] ? 0 : 1);
            } else {
              cont = cont * 1;
              verify = verify * 1;
            }
          }
        }
      } else {
        cont = cont * (data.general[keysFormGeneral[i]] ? 1 : 0);
        verify = verify * (e.general[keysFormGeneral[i]] ? 0 : 1);
      }
    }

    for (let i = 0; i < keysFormAddress.length; i++) {
      if (keysFormAddress[i] == "intnum") {
        cont = cont * 1;
        verify = verify * 1;
      } else if (keysFormAddress[i] == "zip") {
        let value = data.address["country"];
        for (let j = 0; j < props.catalogs.country.length; j++) {
          let elem = props.catalogs.country[j];
          if (elem.k == value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              cont = cont * (data.address["zip"] ? 1 : 0);
              verify = verify * (e.address["zip"] ? 0 : 1);
            } else {
              cont = cont * 1;
              verify = verify * 1;
            }
          }
        }
      } else if (keysFormAddress[i] == "town") {
        let value = data.address["country"];
        for (let j = 0; j < props.catalogs.country.length; j++) {
          let elem = props.catalogs.country[j];
          if (elem.k == value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              cont = cont * (data.address["town"] ? 1 : 0);
              verify = verify * (e.address["town"] ? 0 : 1);
            } else {
              cont = cont * 1;
              verify = verify * 1;
            }
          }
        }
      } else if (keysFormAddress[i] == "locality") {
        let value = data.address["country"];
        for (let j = 0; j < props.catalogs.country.length; j++) {
          let elem = props.catalogs.country[j];
          if (elem.k == value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              cont = cont * (data.address["locality"] ? 1 : 0);
              verify = verify * (e.address["locality"] ? 0 : 1);
            } else {
              cont = cont * 1;
              verify = verify * 1;
            }
          }
        }
      } else {
        cont = cont * (data.address[keysFormAddress[i]] ? 1 : 0);
        verify = verify * (e.address[keysFormAddress[i]] ? 0 : 1);
      }
    }

    for (let i = 0; i < keysFormSpace.length; i++) {
      if (keysFormSpace[i] == "cc") {
        cont = cont * 1;
        verify = verify * 1;
      } else {
        cont = cont * (data.space[keysFormSpace[i]] ? 1 : 0);
        verify = verify * (e.space[keysFormSpace[i]] ? 0 : 1);
      }
    }
    if(!form.identity.validation_result.risk_level.score_level){
      cont = cont * 1;
      verify = verify * 0;
    }
    
    if (cont * verify) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const change = async (object, field, e) => {
    let f = form;
    let er = errs;

    if (object == "general") {
      if (field == "bdate") {        
        f["general"][field] = new Date(e.target.value).toISOString();
      } else if (field == "code") {
        setCodeCom(e.target.value);
        if (!e.target.value) {
          setErrCodeCom(true);
        } else {
          setErrCodeCom(false);
        }
      } else if (field == "bcountry") {
        f["general"][field] = e.target.value;
        if (!e.target.value) {
          er["general"][field] = true;
        } else {
          er["general"][field] = false;
        }
        for (let i = 0; i < props.catalogs.country.length; i++) {
          f["general"]["bstate"] = "";
          er["general"]["bstate"] = false;
          let elem = props.catalogs.country[i];
          if (elem.k == e.target.value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              setStateDisabled(false);
            } else {
              setStateDisabled(true);
            }
          }
        }

      } else {
        f["general"][field] = e.target.value;
        if (!e.target.value) {
          er["general"][field] = true;
        } else {
          er["general"][field] = false;
        }

        if (field == "taxid") {
          f["general"]["populationid"] = e.target.value;
          f["general"][field] = e.target.value.toUpperCase();
          if (!e.target.value) {
            er["general"]["populationid"] = true;
          } else {
            er["general"]["populationid"] = false;
          }
          if (!REGEX_TAXID.test(e.target.value)) {
            er["general"]["taxid"] = true;
          } else {
            er["general"]["taxid"] = false;
          }
        }

        if (field == "email") {
          if (!REGEX_EMAIL.test(e.target.value)) {
            er["general"][field] = true;
          } else {
            er["general"][field] = false;
          }
        }

        if (field == "phone") {
          f["general"][field] = e.target.value.replace(/\D/, "");
          if (!REGEX_PHONE.test(`+${codeCom}${e.target.value}`)) {
            er["general"][field] = true;
          } else {
            er["general"][field] = false;
          }
        }
      }
    }

    if (object == "address") {
      f["address"][field] = e.target.value;
      if (!e.target.value) {
        er["address"][field] = true;
      } else {
        er["address"][field] = false;
      }
      if (field == "country") {
        f["address"].zip = "";
        f["address"].state = "";
        f["address"].town = "";
        f["address"].locality = "";
        for (let i = 0; i < props.catalogs.country.length; i++) {
          let elem = props.catalogs.country[i];
          if (elem.k == e.target.value) {
            if (elem.v == "Mexico" || elem.v == "México") {
              setDisabledCP(false);
            } else {
              f["address"].state = "33";
              setDisabledCP(true);
            }
          }
        }
      }
      if (field == "zip") {
        if (f["address"].zip.length == 5) {
          let zipCatalog = await getCatalog("zip", f["address"].zip);
          if ( zipCatalog.status == 200 && zipCatalog.data.data.response == "OK") {
            let cat = [];
            f["address"].state = "";
            f["address"].town = "";
            for (let i = 0; i < zipCatalog.data.data.catalog.length; i++) {
              cat.push(zipCatalog.data.data.catalog[i]["m"][0].township);
            }
            setCols(cat);
            f["address"].state = zipCatalog.data.data.catalog[0]?.["m"]?.[0]?.state_key;
            f["address"].town = zipCatalog.data.data.catalog[0]?.["m"]?.[0]?.municipality;
            f["address"].locality = "";
            er["address"].locality = false;
            /*l[ob] = cat;                        
							c[ob]['state'] = zipCatalog.data.data.catalog[0]?.['m']?.[0]?.state_key;
							c[ob]['town'] = zipCatalog.data.data.catalog[0]?.['m']?.[0]?.municipality;*/
          }
        }
        if (f["address"].zip.length > 5) {
          f["address"][field] = e.target.value.substring(0, 5);
        }
      }

      if (field == "intnum") {
        er["address"]["intnum"] = false;
      }
    }

    if (object == "space") {
      f["space"][field] = e.target.value;
      if (!e.target.value) {
        er["space"][field] = true;
      } else {
        er["space"][field] = false;
      }

      if (field == "cc") {
        er["space"]["cc"] = false;
      }

      if (field == "account_number") {
        let value = e.target.value;
        if ( !REGEX_NUMBER.test(value) || value.length < 0 || value.length > 20 ) {
          er["space"][field] = true;
        } else {
          er["space"][field] = false;
        }
      }
    }

    if (object == "identity") {
      f["identity"]["validation_result"]["risk_level"][field] = e.target.value;
    }


    verifyForm(f, er);
    setErrs(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const getCatalog = async (name, zip) => {
    props.changeLoader(true);
		setZPos(-1)
    let data = {
      catalog: {
        id: name,
        filters: [
          {
            key: zip,
          },
        ],
      },
    };

    let catalog = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
		setZPos(45)
    return catalog;
  };

  const send = async (data) => {
    props.changeLoader(true);
		setZPos(-1)

    let response = await API.service( "createAfbCustomer", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (response.status === 200) {
      if (response.data.data.response == "OK") {
        props.changeAlert(true, "success", "Cliente creado con éxito");
        closelightbox();
      } else {
        let f = form;
        f["general"]["phone"] = f["general"]["phone"].replace(
          `+${codeCom}`,
          ""
        );
        setForm(JSON.parse(JSON.stringify(f)));
        let detail = "";
        if (response.data.data.code == "0003.003.037") {
          detail = " Email ya existe.";
        } else if (response.data.data.code == "0003.003.036") {
          detail = " Teléfono ya existe.";
        } else if (response.data.data.code == "0003.003.035") {
          detail = " RFC ya existe.";
        }
        props.changeAlert(true, "error", "Error al crear Cliente." + detail);
      }
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const create = async () => {
    let f = form;
   
    f["general"]["phone"] = `+${codeCom}${f["general"]["phone"]}`;
    f["general"]["corporate_name"] = `${f["general"]["lname"]}`;

    await send({ data: f });
  };

  const validate = (ob, field) => {
    if (errors[ob]?.[field]) {
      return "input-error";
    }
    return "";
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabledButton)}>
        <DialogTitle>
					Crear nueva cuenta afb
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

				<Box sx={{ borderBottom: 1, borderColor: 'divider'}} >
					<Tabs value={0} >
						<Tab label="Alta manual" onClick={changeTab.bind(this, "manual")}  sx={{borderBottom: tabActive === "manual" ? "#3743aa solid 2px" : ""}} style={{textAlign: "left", alignItems: "baseline", paddingLeft: "26px"}} />
						{/* <Tab label="Alta por script" onClick={changeTab.bind(this, 'script')}  sx={{borderBottom: tabActive === "script" ? "#3743aa solid 2px" : ""}}/> */}
					</Tabs>
				</Box>
        
        <DialogContent style={{overflowY: "hidden"}}>
          <Grid container spacing={2}>
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							Datos de Empresa
            </Grid>
						<Grid item xs={6}>
							<TextField
								label="Fecha de Creación"
                value={form.general["bdate"] ? new Date(form.general["bdate"]).toJSON().substr(0, 10) : form.general["bdate"]}
								onChange={change.bind(this, "general", "bdate")}
								type={"date"}
								size="small"
								fullWidth
								InputLabelProps={{ shrink: true }}								
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Nombre de la Empresa" value={form.general.gname} onChange={change.bind(this, "general", "gname")} error={errs.general.gname} helperText={errs.general.gname ? 'Dato obligatorio' : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Razón Social" value={form.general.lname} onChange={change.bind(this, "general", "lname")} error={errs.general.lname} helperText={errs.general.lname ? 'Dato obligatorio' : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="RFC de la Empresa" value={form.general.taxid} onChange={change.bind(this, "general", "taxid")} error={errs.general.taxid} helperText={errs.general.taxid ? 'Alfanumérico de 12 a 13 caracteres' : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6} sx={{ display: "flex" }}>
							<TextField
								label="Código País"	value={codeCom}	onChange={change.bind(this, "general", "code")} select size="small"	sx={{ marginRight: "10px" }} style={{ width: "45%" }} InputLabelProps={{ shrink: true }}	error={errCodeCom} helperText={errCodeCom ? 'Dato obligatorio' : ''}>
								{props.catalogs.country.map((item, index) => {
									return (
										<MenuItem key={`state-${index}`} value={item.m[0].dial}>
											(+{item.m[0].dial}) {item.m[0].code2}
										</MenuItem>
									);
								})}
							</TextField>
							<TextField
								label="Teléfono Empresa" value={form.general.phone} onChange={change.bind(this, "general", "phone")} size="small" style={{ width: "55%" }} InputProps={{ style: { height: "40px"}}} error={errs.general.phone} helperText={errs.general.phone ? 'Longitud de 6 a 14 dígitos' : ''}/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Correo Electrónico de la Empresa" value={form.general.email} onChange={change.bind(this, "general", "email")} error={errs.general.email} helperText={errs.general.email ? "Email inválido" : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
              <TextField
                label="Giro de la Empresa" value={form.general.occupation} select onChange={change.bind(this, "general", "occupation")} size="small" fullWidth error={errs.general.occupation} helperText={errs.general.occupation ? 'Dato obligatorio' : ''} >
								{props.catalogs.economicActivities?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="País de Constitución" value={form.general.bcountry} select onChange={change.bind(this, "general", "bcountry")} size="small" fullWidth error={errs.general.bcountry} helperText={errs.general.bcountry ? 'Dato obligatorio' : ''} >
								{props.catalogs.country?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Estado" value={form.general.bstate} select onChange={change.bind(this, "general", "bstate")} disabled={stateDisabled} size="small" fullWidth error={errs.general.bstate} helperText={errs.general.bstate ? 'Dato obligatorio' : ''} >
								{props.catalogs.states?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>

						{/* ----------------------------------------------------- */}
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							<hr/>
							Dirección       
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="País" value={form.address.country} select onChange={change.bind(this, "address", "country")} size="small" fullWidth error={errs.address.country} helperText={errs.address.country ? 'Dato obligatorio' : ''} >
								{props.catalogs.country?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Código Postal" value={form.address.zip} onChange={change.bind(this, "address", "zip")} disabled={disabledCP} size="small" fullWidth error={errs.address.zip} helperText={errs.address.zip ? 'Dato obligatorio' : ''} inputProps={{ maxLength: 5}}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Estado" value={form.address.state || ""} onChange={change.bind(this, "address", "state")} disabled select size="small" fullWidth error={errs.address.state} helperText={errs.address.state ? 'Dato obligatorio': ''} >
								{props.catalogs.states.map((item, index) => (
									<MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Alcaldia / Municipio" value={form.address.town || ""} onChange={change.bind(this, "address", "town")} disabled size="small" fullWidth error={errs.address.town} helperText={errs.address.town ? 'Dato obligatorio' : ''}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Colonia" value={form.address.locality || ""} disabled={disabledCP} select onChange={change.bind(this, "address", "locality")} size="small" fullWidth error={errs.address.locality} helperText={errs.address.locality ? 'Dato obligatorio' : ''} >
								{cols?.map((item, index) => (
                  <MenuItem key={`address-${index}`} value={item}>{item}</MenuItem>
                ))}
							</TextField>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Calle" value={form.address.street} onChange={change.bind(this, "address", "street")} size="small" fullWidth error={errs.address.street} helperText={errs.address.street ? 'Dato obligatorio' : ''} inputProps={{ maxLength: 50 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="No. ext." value={form.address.extnum} onChange={change.bind(this, "address", "extnum")} size="small" fullWidth error={errs.address.extnum} helperText={errs.address.extnum ? 'Dato obligatorio' : ''} inputProps={{ maxLength: 25 }}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="No. int." value={form.address.intnum} onChange={change.bind(this, "address", "intnum")} size="small" fullWidth error={errs.address.intnum} helperText={errs.address.intnum ? 'Dato obligatorio' : ''} inputProps={{ maxLength: 25 }}/>
            </Grid>

						{/* ----------------------------------------------------- */}
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							<hr/>
							Datos de la Cuenta       
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Nombre de la Cuenta" value={form.space.name} onChange={change.bind(this, "space", "name")} size="small" fullWidth error={errs.space.name} helperText={errs.space.name ? 'Dato obligatorio' : ''} />
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Descripción de la Cuenta" value={form.space.description} onChange={change.bind(this, "space", "description")} size="small" fullWidth error={errs.space.description} helperText={errs.space.description ? 'Dato obligatorio' : ''}  />
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Centro de Costos" disabled value={form.space.cc} onChange={change.bind(this, "space", "cc")} size="small" fullWidth error={errs.space.cc} helperText={errs.space.cc ? 'Dato obligatorio' : ''}  />
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Número de Cuenta" value={form.space.account_number} onChange={change.bind(this, "space", "account_number")} size="small" fullWidth error={errs.space.account_number} helperText={errs.space.account_number ? 'Debe tener una longitud máxima de 20 dígitos y solo contener números' : ''} inputProps={{ maxLength: 20}} />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Nivel de Riesgo" value={form.identity.validation_result.risk_level.score_level} select onChange={change.bind(this, "identity", "score_level")} size="small" fullWidth >
                  <MenuItem value={"Bajo"}>Bajo</MenuItem>
                  <MenuItem value={"Medio"}>Medio</MenuItem>
                  <MenuItem value={"Alto"}>Alto</MenuItem>
                
							</TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabledButton} variant="contained" onClick={create.bind(this)} >Crear Cuenta</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default AfbCustomer;
